<template lang="pug">
v-container
  h2 Настройки нейросети для задания
  p.ml-5.mt-4: strong Вопросы с текстовым ответом:
  lazy-load(
    v-model="loadMore"
    @on-response="({ items }) => units.push(items)"
  )
    v-col
      v-card.sdo-card.mb-4(
        width="100%"
        v-for="(item, idx) in units"
        :key="item.id"
      )
        v-list-item.pb-0
          v-list-item-content
            v-list-item-title {{ item.task_unit.title }}
            v-list-item-subtitle {{ item.task_unit.description }}
          v-list-item-action
            v-switch(
              :input-value="item.type !== 0"
              @change="item.type = Number(!item.type); item.handleSave()"
            )
        v-card-text.pt-0(
          v-if="item.type"
        )
          v-btn-toggle.transparent.mb-4(
            light
            v-model="item.type"
            color="white"
            mandatory
            @change="item.handleSave()"
          )
            v-btn.mt-1(
              v-for="btn in typeItems"
              :key="btn.value"
              :value="btn.value"
              :color="item.type === btn.value ? btn.color : ''"
            ) {{ btn.text }}
          v-row.ma-0.align-center.mb-4
            v-avatar(size="48" color="primary").white--text {{ item.auto_percent }}%
            v-slider(
              v-model="item.auto_percent"
              label="Процент уверенности нейросети для самостоятельного ответе"
              thumb-label
              inverse-label
              hide-details
              @change="item.handleSave()"
            )
          v-select.mb-4(
            v-model="item.evaluation_type"
            :items="EVALUATION_TYPES"
            rounded filled
            label="Тип Оценки"
            hide-details
            @change="changeEvaluationType(item)"
          )
          v-row.ma-0
            v-col(v-if="item.evaluation_type === 2")
              v-text-field(
                v-model="item.evaluation_max"
                type="number"
                label="Максимальная оценка"
                rounded filled
                @change="item.handleSave()"
              )
            v-col(v-if="[1,2].includes(item.evaluation_type)")
              v-text-field(
                v-model="item.evaluation_max"
                type="number"
                label="Максимальная оценка"
                rounded filled
                @change="item.handleSave()"
              )
          v-alert(
            type="info"
            icon="mdi-database"
            prominent
            text
            color="secondary"
          )
            v-list-item(light)
              v-list-item-content
                v-list-item-title База знаний:
                v-list-item-subtitle.normal-wrap
                  span {{ item.knowledgeBaseName }}
              v-list-item-action
                v-btn(
                  depressed color="secondary" outlined
                  :icon="$vuetify.breakpoint.mdAndDown"
                  @click="changeBaseKnowledge(item)"
                )
                  v-icon(:left="!$vuetify.breakpoint.mdAndDown") mdi-pencil
                  span(v-if="!$vuetify.breakpoint.mdAndDown") Изменить
</template>
<script>
import GptSettings from '@/models/list/GptSettings';
import AutocompleateBaseKnowledge from './AutocompleateBaseKnowledge.vue';

const EVALUATION_TYPES = [
  { text: 'Оценка школьными баллами', value: 1 },
  { text: 'Оценка от нуля до', value: 2 },
  { text: 'Оценка выполнено/не выполнено', value: 3 },
];
export default {
  data() {
    return {
      EVALUATION_TYPES,
      typeItems: [
        {
          value: 2,
          color: 'primary',
          icon: 'mdi-robot',
          text: 'Предлагает ответ',
        },
        {
          value: 1,
          color: 'success',
          icon: 'mdi-robot-happy',
          text: 'Отвечает самостоятельно ',
        },
      ],
      units: {},
      loadMore: null,
      loading: true,
    };
  },
  created() {
    this.getGptSettings();
  },
  methods: {
    changeEvaluationType(item) {
      if (item.evaluation_type !== 2) item.evaluation_max = null;
      item.handleSave();
    },
    async getGptSettings() {
      const params = {
        'search[task_id]': this.$route.params.id,
        expand: 'task_unit',
      };
      const { items, loadMore } = await this.$api.gptPulse.getTaskGptSettings({ params, rOptions: { model: GptSettings, modelParams: 'task', many: true } });
      this.loadMore = loadMore;
      this.units = items;
    },
    changeBaseKnowledge(item) {
      this.$modals.show('form-controller', {
        title: 'Редактирование базы знаний',
        method: ({ data }) => {
          const { baseKnowledge } = data;
          item.setBaseKnowledge(baseKnowledge);
          return new Promise((resolve) => { resolve({ data: {} }); });
        },
        fields: [{
          component: AutocompleateBaseKnowledge,
          text: 'Выберите базу знаний',
          value: 'baseKnowledge',
          rules: 'required',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        }],
      });
    },
  },
};
</script>
